<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.compartilhamentosCuidado"
            hide-filters
            hide-pagination
        >
            <template v-slot:cell(ciap)="{item}">
                {{item.ciap ? `${item.ciap.codigo} - ${item.ciap.descricao}` : ''}}
            </template>

            <template v-slot:cell(cid)="{item}">
                {{item.cid ? `${item.cid.codigo} - ${item.cid.nome}` : ''}}
            </template>

            <template v-slot:cell(actions)="{index, item}">
                <rkm-button
                    @click="$refs.Modal.open(item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="destroy(index)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

export default {
    components: {Modal},
    data: () => ({
        fields: [
            {key: 'usuario.cidadaoNome', label: 'Profissional', sortable: true},
            {key: 'ciap', label: 'CIAP 2', sortable: true},
            {key: 'cid', label: 'CID 10', sortable: true},
            {key: 'classificacaoRisco.nome', label: 'Classificação de risco', sortable: true},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
    }),
    methods: {
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o compartilhamento de cuidado?', async () => {
                this.data.model.compartilhamentosCuidado.splice(index, 1)
            })
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>